import { Witness } from './Witness';
export default Witness;